// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"c488c6dd","285":"55d179ed","365":"23de5e4f","487":"c3ef1076","805":"69dbf60d","983":"61cb9022"}[chunkId] + ".chunk.css";
};